export const MINHA_TELY_LOGIN =
  'https://minhately.tely.com.br/app_login/index.php?_gl=1*3n7cam*_ga*NDIwODI0MDcuMTY4MTI1ODI2Ng..*_ga_T2X68YXSD7*MTY4MTI1ODI2Ni4xLjAuMTY4MTI1ODI2Ni4wLjAuMA..'
